import React, { useEffect, useState } from "react";
import { Carousel } from "antd";
import axios from "axios";
import "./Carousel.css";
import { getConfig } from "../config";

const CustomCarousel: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
    // Mock API
    const fetchImages = async () => {
      try {
        const { data } = await axios.get<string[]>("/images");
        setImages(
          data.map(
            (imgName) => `${getConfig().BASE_URL_API}/api/images/${imgName}`
          )
        );
      } catch (err) {
        console.error("Failed to fetch carousel images", err);
      }
    };

    fetchImages();
  }, []);

  if (images.length === 0) {
    return <div className="carousel-loading">Loading carousel...</div>;
  }

  return (
    <div className="custom-carousel">
      <Carousel autoplay dots autoplaySpeed={4000} arrows>
        {images.map((url, idx) => (
          <div key={idx} className="carousel-slide">
            <img src={url} alt={`slide-${idx}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CustomCarousel;
